module.exports = __webpack_public_path__ + "static/media/logo-epa-link.050508c5.svg";